module.exports = __webpack_public_path__ + "img/cangchu2.af4df85d.jpg";